import type {Ref} from 'react';
import type {CheckoutStepProps} from '@Components/checkout-flow/checkout-flow.types';

/** Kept as the legacy id so the Playwright checkout page object keeps finding the field. */
export const PROMO_CODE_INPUT_ID = 'promo-code';
export const PROMO_CODE_PLACEHOLDER = 'PROMO2024';

export interface PromoCodeInputProps extends CheckoutStepProps {
  ref?: Ref<HTMLDivElement>;
}

/** Named rather than positional: these are all strings, so a swapped pair would compile and invert the discount. */
export interface PromoDiscountDetails {
  discountType: string;
  discountAmount: string;
  beforeDiscountPrice: string;
  discountedPrice: string;
  currencyCode: string;
}
